var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRejected = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2347_9595)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H16V16H0V0Z",
  fill: "#FFEBE6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.00004 1.33398C4.32004 1.33398 1.33337 4.32065 1.33337 8.00065C1.33337 11.6807 4.32004 14.6673 8.00004 14.6673C11.68 14.6673 14.6667 11.6807 14.6667 8.00065C14.6667 4.32065 11.68 1.33398 8.00004 1.33398ZM2.66671 8.00065C2.66671 5.05398 5.05337 2.66732 8.00004 2.66732C9.23337 2.66732 10.3667 3.08732 11.2667 3.79398L3.79337 11.2673C3.08671 10.3673 2.66671 9.23398 2.66671 8.00065ZM8.00004 13.334C6.76671 13.334 5.63337 12.914 4.73337 12.2073L12.2067 4.73398C12.9134 5.63398 13.3334 6.76732 13.3334 8.00065C13.3334 10.9473 10.9467 13.334 8.00004 13.334Z",
  fill: "#992400"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2347_9595"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRejected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rejected.30ae6b2155ebab3319db369decb72b2f.svg";